export default "__VITE_ASSET__ChmjE3Am__"